import { parsePrivateLink } from '@/shared/utils/private-link';
import axios, { type AxiosInstance } from 'axios';

// Standalone axios instance. Lives in its own file so frontend-alert.ts
// can import it without dragging in axios.ts's interceptors (which call
// back into frontend-alert.ts via reportNetworkError) — that would form
// a module cycle. axios.ts attaches the interceptors to this same
// instance and re-exports it for compat.

const baseURL = parsePrivateLink(import.meta.env.VITE_BASE_API);

export const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 60_000 * 15,
});
